import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import YoutubeLogo from '../assets/youtube.svg';
import QR from '../assets/Q for Quantessence Red.svg';
import QuantessenceR from '../assets/Quantessence Red.svg';
import LinkedinLogo from '../assets/linkedin.svg';
import EuroclearLogo from '../assets/euroclearLogo.png';
import '../index.css';

// Footer links
const footerLinks = [
  { to: '/privacypolicy', labelKey: 'footer.privacyPolicy' },
  // { to: '/employeepolicy', labelKey: 'footer.employeePolicy' },
  { to: '/legalnotice', labelKey: 'footer.legalNotice' },
];

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className='flex flex-col justify-center items-center p-6 md:p-12 gap-6 md:gap-12 border-t border-2px'>
      <div className='flex flex-col gap-6'>
        <div className='flex flex-col justify-center items-center gap-6'>
          <img className='h-12' src={QR} alt='logo' loading='lazy' />
          <div className='flex flex-col items-center gap-2'>
            <img className='h-6' src={QuantessenceR} alt='euroclearcompany' loading='lazy'/>
            <p className='font-medium text-xl text-[#DF3C44]'>
              {t('footer.euroclearCompany')}
            </p>
          </div>
        </div>
        <div className='flex justify-center gap-6'>
          {/* <a
            href='https://www.youtube.com/@quantessenceltd.3054'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src={YoutubeLogo} alt='Youtube' className='h-8 w-8' />
          </a> */}
          <a
            href='https://www.linkedin.com/company/quantessence-financial-ltd/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src={LinkedinLogo} alt='Linkedin' className='h-8 w-8' loading='lazy' />
          </a>
          <a
            href='https://www.euroclear.com/en.html'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src={EuroclearLogo} alt='Euroclear' className='w-10' loading='lazy' />
          </a>
        </div>
        <div className='flex flex-wrap justify-center gap-2 md:gap-6'>
          {footerLinks.map((link, index) => (
            <Link
              key={index}
              className='text-primary-blue text-lg'
              to={link.to}
            >
              {t(link.labelKey)}
            </Link>
          ))}
        </div>
      </div>
      <div className='flex justify-center pt-4 w-full border-t border-2px text-center'>
        <p className='font-light text-sm text-primary-blue'>
          {t('footer.copyright', { year: currentYear })}
        </p>
      </div>
    </footer>
  );
}

export default Footer;